import { enumBrowsers } from "../constants";
import { HandleFireFoxKeyEvent } from "./HandleFireFoxKeyEvent";
import { HandleBrowserKeyEvent } from "./HandleBrowserKeyEvent";
import { QKeyBoardInfo } from "./QKeyBoardInfo";
import { Globals } from "../CoreApp/Globals";

export function EventToKeyInfo(event, keySource) {
  var k = new QKeyBoardInfo();
  k.ignoreEvent = true;
  k.source = keySource;

  switch (Globals._userBrowser) {
    case enumBrowsers.FireFox:
      HandleFireFoxKeyEvent(event, k);
      break;
    case enumBrowsers.Chrome:
    case enumBrowsers.Other:
    case enumBrowsers.Safari:
      HandleBrowserKeyEvent(event, k);
      break;
    default:
      break;
  }

  return k;
}
